import { render, staticRenderFns } from "./CommunityFamilyAssignment.vue?vue&type=template&id=76c901ba&scoped=true&"
import script from "./CommunityFamilyAssignment.vue?vue&type=script&lang=js&"
export * from "./CommunityFamilyAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c901ba",
  null
  
)

export default component.exports